import { addMinutes } from "date-fns";
import { useFormik } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTimer } from "react-timer-hook";
import { toast } from "react-toastify";
import * as yup from "yup";
import { forgotPassword, resetPassword } from "../../../Services/AuthService";
const validationSchema = yup.object({
  password: yup.string().required("This field is required..."),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("This field is required..."),
});

export const ChangePassword = () => {
  const [submitting, setSubmitting] = React.useState(false);
  const navigate = useNavigate();
  const [timeStamp, setTimeStamp] = React.useState(new Date());
  const [disabled, setDisabled] = React.useState(false);
  const customer = useSelector((x) => x.Customer);
  const [values, setValues] = React.useState({
    1: "",
    2: "",
    3: "",
    4: "",
  });
  const { seconds, minutes, restart, isRunning } = useTimer({
    expiryTimestamp: timeStamp,
    onExpire: () => setTimeStamp(null),
  });
  const [loading, setLoading] = React.useState(false);
  const [resetToken, setResetToken] = React.useState("");
  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
      fcm_token: "dfskjfkjshfksdhfdskhfsdfkh",
    },
    validationSchema,
    onSubmit: (v) => {
      const ex = /^[0-9][0-9][0-9][0-9]$/gm;
      if (formik.isValid && ex.test(resetToken)) {
        console.log(v);
        const payload = {
          phone: customer?.phone,
          reset_token: resetToken,
          password: v.password,
          confirm_password: v.confirm_password,
        };
        setSubmitting(true);
        resetPassword(payload).then(
          (res) => {
            setSubmitting(false);
            toast.success(res.message);
            navigate("/app", { replace: true });
          },
          ({ errors }) => {
            setSubmitting(false);
            if (errors?.length > 0) {
              errors.forEach((z) => {
                toast.error(z.message, { autoClose: 5000 });
              });
            }
          }
        );
      } else if (!ex.test(resetToken)) toast.error("Please enter a valid OTP!");
      else if (!formik.isValid) toast.error("Please fill all form fields!");
    },
  });
  const handleChange = (e) => {
    const id = e?.["target"]?.["id"];
    const v = e?.["target"]?.["value"];
    const b = id?.["split"]("-");
    const index = b[b?.["length"] - 1];

    const nv = { ...values };
    nv[index] = v;
    setValues((values) => {
      return nv;
    });
    if (index === "4") {
      e?.["target"]?.["blur"]();
      finalHandle(nv);
    } else {
      b[b?.["length"] - 1] = parseInt(index) + 1;
      const nId = b?.["join"]("-");
      document?.["getElementById"](nId)?.["focus"]();
    }
  };
  const handlePaste = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData("Text");
    let xy = false;
    if (pastedData.length === 4) {
      const vs = pastedData.split("");
      for (let i = 0; i < vs.length; i++) {
        const x = vs[i];
        const rx = /^[0-9]$/gm;
        if (!rx.test(x)) {
          xy = true;
          return;
        }
      }
      if (!xy) {
        const tx = {};
        vs.forEach((vvv, i) => {
          tx[i + 1] = vvv;
        });
        setValues(tx);
        finalHandle(tx);
      }
    } else xy = true;

    if (xy) {
      toast.error("Invalid OTP");
    }
  };
  const finalHandle = (vv) => {
    console.log(vv);
    const otp = Object.values(vv).join("");
    console.log(otp);
    const ex = /^[0-9][0-9][0-9][0-9]$/gm;
    if (ex.test(otp)) {
      setResetToken(otp);
    } else toast.error("Please enter a valid OTP!");
  };
  const resend = () => {
    setLoading(true);

    forgotPassword({ phone: customer?.phone })
      .then(
        (res) => {
          if (res.status) toast.success("OTP sent successfully!");
        },
        (er) => {}
      )
      .finally(() => {
        setLoading(false);
        restart(addMinutes(Date.now(), 1), true);
      });
  };
  React.useEffect(() => {
    const payload = { phone: customer?.phone };
    forgotPassword(payload).then(
      (res) => {
        restart(addMinutes(Date.now(), 1), true);
      },
      ({ errors }) => {
        if (errors?.length > 0) {
          errors.forEach((z) => {
            toast.error(z.message, { autoClose: 5000 });
          });
        }
      }
    );
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row align-items-center" style={{ minHeight: "83vh" }}>
          <div className="col-md-7 col-12">
            <div className="row">
              <div
                style={{ height: "calc(83vh - 160px)" }}
                className="col-12 d-flex justify-content-center flex-column align-items-center"
              >
                <form
                  className="col-lg-6 col-md-8 col-11"
                  onSubmit={formik.handleSubmit}
                >
                  <div>
                    <span
                      style={{
                        fontSize: "35px",
                        display: "block",
                        color: "#232323",
                      }}
                      className="fw-bold"
                    >
                      Change Password
                    </span>
                    <span
                      style={{
                        fontSize: "18px",
                        display: "block",
                        color: "#969696",
                      }}
                    >
                      Enter and confirm your new password!
                    </span>
                  </div>
                  <Form.Group className="my-3" controlId="password">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="New Password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${
                        Boolean(formik.errors.password) &&
                        formik.touched.password
                          ? "is-invalid"
                          : "mb-3"
                      }`}
                    />
                    {Boolean(formik.errors.password) &&
                    formik.touched.password ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.password}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Control
                      type="password"
                      id="confirm_password"
                      name="confirm_password"
                      placeholder="Confirm New Password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${
                        Boolean(formik.errors.confirm_password) &&
                        formik.touched.confirm_password
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {Boolean(formik.errors.confirm_password) &&
                    formik.touched.confirm_password ? (
                      <Form.Text className="text-danger">
                        {formik.errors.confirm_password}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <span
                    style={{
                      fontSize: "13px",
                      display: "block",
                      color: "#969696",
                    }}
                    className="text-start"
                  >
                    Enter the verification code we just sent to your number
                  </span>
                  <div className="otp-input-container justify-content-start py-2">
                    <input
                      type="number"
                      className="otp-input"
                      id="otp-input-1"
                      onPaste={handlePaste}
                      onChange={handleChange}
                      style={{
                        backgroundColor: disabled ? "#e2e2e2" : "#f9f9f9",
                        color: disabled ? "#9f9f9f" : "#282828",
                      }}
                      value={values[1]}
                      autoFocus
                    />
                    <input
                      type="number"
                      className="otp-input"
                      id="otp-input-2"
                      onPaste={handlePaste}
                      onChange={handleChange}
                      style={{
                        backgroundColor: disabled ? "#e2e2e2" : "#f9f9f9",
                        color: disabled ? "#9f9f9f" : "#282828",
                      }}
                      value={values[2]}
                    />
                    <input
                      type="number"
                      className="otp-input"
                      id="otp-input-3"
                      onPaste={handlePaste}
                      onChange={handleChange}
                      style={{
                        backgroundColor: disabled ? "#e2e2e2" : "#f9f9f9",
                        color: disabled ? "#9f9f9f" : "#282828",
                      }}
                      value={values[3]}
                    />
                    <input
                      type="number"
                      className="otp-input"
                      id="otp-input-4"
                      onPaste={handlePaste}
                      onChange={handleChange}
                      style={{
                        backgroundColor: disabled ? "#e2e2e2" : "#f9f9f9",
                        color: disabled ? "#9f9f9f" : "#282828",
                      }}
                      value={values[4]}
                    />
                  </div>
                  <small className="pb-3 d-block">
                    Didn't receive code?
                    {loading ? (
                      <span className="px-2">
                        <Spinner variant="primary" size="sm" />
                      </span>
                    ) : (
                      <>
                        {minutes != 0 || seconds != 0 ? (
                          <span className="px-2">
                            <span className=" fw-semibold">
                              {minutes < 10 ? `0${minutes}` : minutes}:
                              {seconds < 10 ? `0${seconds}` : seconds}
                            </span>
                          </span>
                        ) : (
                          <>
                            <span
                              className=" fw-semibold text-primary px-2"
                              onClick={() => resend()}
                            >
                              Resend
                            </span>
                          </>
                        )}
                      </>
                    )}
                  </small>
                  <button className="login-btn" type="submit">
                    {submitting ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    ) : null}
                    Save
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-5 d-none d-md-block py-2">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/img_react_signin.jpg"}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                maxHeight: "95vh",
                borderRadius: "24px",
                backgroundColor: "#aaa",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
